import { Breadcrumb } from "antd";
import React from "react";
import { useEffect } from "react";
import { Card } from "react-bootstrap";
import { PageTitle } from "../../../components/PageTitle";
import { useOrder } from "./useOrder";
import { useHistory } from "react-router";
import { PageLoader } from "../../../components/Loaders";
import "../farmers/components/table.css";
const image =
  "data:image/png;base64,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";

type FarmerDetailsType = {
  match: {
    params: {
      id: string;
      manufacturer: string
    };
  };
};
const DMAOrderDetails: React.FC<FarmerDetailsType> = ({ match }) => {
  //Hooks

  const history = useHistory();
  //state
  const { dmaOrderDetails,  getDmaOrderDetails, isFetchingOrderDetails, sumOrders } = useOrder();

  const id = match.params.id;
  const manufacturer = match.params.manufacturer

  //Effect
  useEffect(() => {
    getDmaOrderDetails(id,manufacturer);
  }, [id]);

  if(isFetchingOrderDetails){
    return <div className="d-flex align-items-center justify-content-center"> <PageLoader/></div>
  }
  return (
    <div className="pt-5 container ">
      <Breadcrumb separator=">">
        <Breadcrumb.Item onClick={() => history.push("/dma")}>
          Home
        </Breadcrumb.Item>
        <Breadcrumb.Item onClick={()=>history.push("/dma/my-orders")}>My Orders</Breadcrumb.Item>
        <Breadcrumb.Item href="">Order details</Breadcrumb.Item>
      </Breadcrumb>

      <PageTitle title={"My Order Details"} />
      <Card className="col-md-12 text-align-center container pt-5">

        <div className="subtext-pc fw-500 mt-3 mb-5">Order #{dmaOrderDetails?.orderId}</div>
       <div className="table-responsive">
        <div className="mt-5 table-wrapper shadow">
        <table style={{"width": "100%"}}>

          
      <thead>
        <tr>
          <th style={{"width": "30%"}}>Product Name</th>
          <th>Type</th>
          <th>Size</th>
          <th>Price</th>
          <th>Quantity</th>
          <th>Cost</th>
        </tr>
      </thead>
      <tbody>
        <>
        {dmaOrderDetails?.orderItems && dmaOrderDetails?.orderItems.length! > 0 ? (
         dmaOrderDetails?.orderItems?.map((order, index) => (
            <tr key={index}>
              <td>
                <div className="d-flex gap-30 align-items-center">
                  <img
                    src={(Array.isArray(order?.product?.image) ? (order?.product?.image && order?.product?.image[0]) : order?.product?.image) || image }
                    width={93}
                    height={131}
                    className={"object-fit-contain"}
                    alt={"image"}
                  />
                  <div>
                    <div>{order?.product?.name}</div>
                    <div className="seller mt-2">Seller: {order?.product?.company_name}</div>
                  </div>
                </div> 
              </td>
              <td className="grey">{order?.product?.type}</td>
              <td className="grey">{`${order?.product?.unit}`}</td>
              <td>
                {order?.product?.price}
              </td>
              <td>
                {order?.quantity}
            
              </td>
              <td className="fw-500">
                Ksh {(order?.product?.price! * order?.quantity!) || 0}
              </td>
            
            </tr>
        
          ))
        ) : (
          <tr>
            <td colSpan={6} className="text-align-center p-5 fs-24 grey-color">
              Product list is empty
            </td>
          </tr>
        )}
       
        </>
      </tbody>
    </table>
        </div>
        <div className={'d-flex justify-content-end mb-4 mt-4'}>
        <div className="d-flex col-md-3">
              <div className="col-md-5 text-align-right mr-3">Total: </div>
              <div className="col-md-7 primary-color fw-500 text-align-left">
                Ksh {sumOrders()}
              </div>
            </div>
        </div>
       </div>
      </Card>
    </div>
  );
};

export default DMAOrderDetails;
